
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","height":"40","viewBox":"0 -960 960 960","width":"40","fill":"#5f6368"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M699.67-142.67l139-138-42-42-97 95-39-39-42 43 81 81zM240-613.33h480V-680H240v66.67zM728.33-40.67q-79.33 0-135.5-56.5-56.16-56.5-56.16-134.83 0-79.96 56.16-136.31 56.16-56.36 135.84-56.36 79 0 135.5 56.36 56.5 56.35 56.5 136.31 0 78.33-56.5 134.83-56.5 56.5-135.84 56.5zM120-80.67v-692.66q0-27.5 19.58-47.09Q159.17-840 186.67-840h586.66q27.5 0 47.09 19.58Q840-800.83 840-773.33v307q-15.78-7.57-32.39-12.62Q791-484 773.33-487v-286.33H186.67v586.66h287.66q3.59 22.45 11.13 42.73Q493-123.67 504-104.67l-24 24-60-60-60 60-60-60-60 60-60-60-60 60zM240-280h235.85q3.48-17.67 8.48-34.33 5-16.67 13.34-32.34H240V-280zm0-166.67h350.67q27.33-19.66 60.16-31.16 32.84-11.5 69.17-12.84v-22.66H240v66.66zm-53.33 260v-586.66 586.66z"}})])
          )
        }
      }
    